import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

import NavBreadcrum from "components/NavBreadcrum";
import TopBarActions from "components/TopBarActions";
import { SwalAlertClass, SwalAlertChoice } from "core/swalClass";
import LoaderSpinner from "context/LoaderSpinner";
import { arrayToObjectByPairs } from "core/utils/arrays";
import ButtonsActions from "views/utils/buttonsActions";
import BoxFilterDevices from "./devices/BoxFiltersDevices";
import PrevAssetDevices from "./devices/PrevAssetDevices";
import TableAssetDevices from "./devices/TableAssetDevices";
import FormDevice from "./devices/FormDevice";
import { DeviceModel } from "site-apps/devices/DevicesModels";
import DeviceStatus from "site-apps/devices/DeviceStatus";
import FilterModel from "components/FilterModel";
import ItemsModel from "core/itemsModel";
import navs from "./navs";
import axiApi from "ApiCaller";
import { toLowCaseCleanSpaces } from "core/utils/Texts";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import { PagerModel } from "components/paginator/PaginationModel";
import { translations } from "./translations";
import useCustomTranslation from "core/customTranslation";
import ConditionalRender from "components/ConditionalRender";
import OrderingModel from "components/ordering/OrderingModel";
import ModalDeviceMassive from "./devices/ModalDeviceMassive";

const ViewDevices = () => {
    const { t: _Tr } = useTranslation("routes");
    const { t: _Tt } = useTranslation("tables");
    const { t: _Tc } = useCustomTranslation(translations);

    const Alert = new SwalAlertClass({ confirmButtonText: "Aceptar" });
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    const bread = [
        {
            name: _Tr("labels.asset-management"),
            url: "/asset-management/",
            current: false,
        },
        { name: _Tr("labels.devices"), current: true },
    ];
    document.title = _Tr("labels.devices");
    const [urlQuery] = useSearchParams();
    const items = useRef(new ItemsModel());
    const [item, setItem] = useState({ ...DeviceModel });
    const [itemsShow, setItemsShow] = useState([]);
    const [showModalMassive, setShowModalMassive] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const pagerModelRef = useRef(new PagerModel());
    const filters = useRef(new FilterModel());
    const [selectAll, setSelectAll] = useState(false);
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = document.title;
        return buttonsAct;
    });
    const [isLoading, setIsLoading] = useState(false);
    // variables form
    const [showForm, setShowForm] = useState(false);
    const [titleForm, setTitleForm] = useState("Modificar");
    // -
    const orderingRef = useRef(new OrderingModel());
    const [params, setParams] = useState({
        types: [],
        models: [],
        groups: [],
        status: [],
        statusList: [],
        itemsShown: [],
    });
    const itemsRef = useRef([]);

    const headersTable = [
        { name: _Tt("devices.UUID"), attr: 0, direction: "asc", active: true, default: true },
        { name: _Tt("devices.serial"), attr: 1, direction: "asc", active: false },
        { name: _Tt("devices.type"), attr: 2, direction: "asc", active: false },
        { name: _Tt("devices.config_name"), attr: 3, direction: "asc", active: false },
        { name: _Tt("devices.status"), attr: 4, direction: "asc", active: false },
        { name: _Tt("devices.asset"), attr: 5, direction: "asc", active: false },
        { name: _Tt("devices.groups_devices"), attr: 6, direction: "asc", active: false },
        { name: _Tt("devices.last_communication"), attr: 7, direction: "asc", active: false },
    ];

    useEffect(() => {
        setIsLoading(true);
        const buttons = { ...buttonsTB };
        buttons.title = document.title;
        buttons.edit.active = true;
        buttons.edit.onClick = onClickEdit;
        buttons.filter.active = true;
        buttons.filter.onClick = onClickFilter;
        //buttons.add.active = true;
        //buttons.add.onClick = onClickAdd;
        buttons.delete.active = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            applyFilters();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => {
            applyFilters();
        };
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = DeviceModel;
        fetchGetItems();
    }, []);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = { ...buttonsTB };
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        applyFilters();
    };

    function onClickFilter() {
        const buttons = { ...buttonsTB };
        buttons.filter.click = !buttonsTB.filter.click;
        buttons.counter = items.current.showed.length;
        setButtonsTB(buttons);
    }

    const onClickDelete = () => {
        AlertQuestion.warning(_Tc("alert.delete"), `Se borraran los ${items.current.chosen.length} seleccionados`).then(
            (resp) => {
                if (resp.isConfirmed) {
                    let uuids = [];
                    uuids = items.current.getChosenUuids();
                    setIsLoading(true);
                    axiApi
                        .post(`/api/devices/delete/`, { items: uuids })
                        .then((resp) => {
                            if (resp.status) {
                                items.current.showed = items.current.showed.filter((item) => !uuids.includes(item.uuid));
                                items.current.all = items.current.all.filter((item) => !uuids.includes(item.uuid));
                                setParams((prev) => ({ ...prev, itemsShown: [...items.current.showed] }));

                                Alert.success(_Tc("alert.delete.success"), _Tc("alert.delete.disp"));
                            }
                        })
                        .catch((error) => {
                            console.error("Error al enviar la solicitud:", error);
                        })
                        .finally(() => {
                            items.current.clearChosen();
                            const buttons = { ...buttonsTB };
                            buttons.edit.disabled = true;
                            buttons.delete.disabled = true;
                            setButtonsTB(buttons);
                            setIsLoading(false);
                            applyFilters();
                        });
                }
            },
        );
    };

    const onClickEdit = () => {

        if (items.current.chosen.length > 1) {
            setShowModalMassive(true);
            return;
        }

        setTitleForm("Modificar");
        let device = items.current.showed.find((item) => item.uuid === items.current.chosen[0]);

        axiApi
            .post("/api/assets/asset/", { uid: device.asset_uid })
            .then((resp) => {
                if (resp.status) {
                    device.asset = resp.data.item;
                    setItem(device);
                    setShowForm(true);
                } else {
                    Alert.warning(_Tc("alert.notify.admin"), _Tc("alert.recovery.asset"));
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
                Alert.error(_Tc("alert.notify.admin"), _Tc("alert.edit.error"));
            })
            .finally(() => {
                setIsLoading(false);
                const buttons = { ...buttonsTB };
                buttons.edit.disable = true;
                buttons.delete.disable = true;
                setButtonsTB(buttons);
            });
    };

    const urlQueryParams = () => {
        if (urlQuery.has("uuid")) {
            let uid = urlQuery.get("uuid");
            filters.current.searcher.ref.value = uid;
            filters.current.chosen.searcher = toLowCaseCleanSpaces(uid);
            filters.current.filter();
            axiApi
                .post("/api/devices/data/", { searcher: toLowCaseCleanSpaces(uid) })
                .then((resp) => {
                    if (!resp.data?.items?.length) return;
                    let device = resp.data.items.find((d) => d.uuid === uid) ?? resp.data.items[0];
                    axiApi
                        .post("/api/assets/asset/", { uid: device.asset_uid })
                        .then((assetResp) => {
                            if (assetResp.status) device.asset = assetResp.data.item;
                        })
                        .finally(() => {
                            setTitleForm("Modificar");
                            setItem(device);
                            setShowForm(true);
                        });
                })
                .catch((error) => console.log(error));
        }
    };

    const fetchGetItems = async () => {
        try {
            const resp = await axiApi.get(`/api/devices/data/`, filters.current.chosen);

            if (resp.data) {
                items.current.showed = [...resp.data.items];
                setItemsShow(items.current.showed);
                setParams((prev) => ({ ...prev, itemsShown: items.current.showed }));
                if (resp.data.pager) {
                    pagerModelRef.current.paging.update(resp.data.pager);
                }

                filters.current.list = {
                    type: resp.data.params.filters.type.map(([id, name]) => ({
                        id,
                        name,
                    })),
                    status: DeviceStatus.map((key) => ({
                        id: key,
                        name: _Tc("devices_status." + key),
                    })),
                    config_name: [...resp.data.params.filters.config_name],
                    groups_devices: [...resp.data.params.filters.groups_devices],
                };

                setParams((prev) => ({
                    ...prev,
                    types: resp.data.params.form.type,
                    models: resp.data.params.form.models,
                    groups: resp.data.params.form.groups,
                    status: arrayToObjectByPairs(resp.data.params.form.status),
                    statusList: resp.data.params.form.status,
                }));

                urlQueryParams();
            }
        } catch (error) {
            console.error("Error al enviar la solicitud:", error);
            const buttons = { ...buttonsTB };
            buttons.filter.applied = false;
            setButtonsTB(buttons);
        }
        setIsLoading(false);
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/devices/data/", filters.current.chosen, {
                params: { ...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams() },
            })
            .then((resp) => {
                items.current.showed = [...resp.data.items];
                setItemsShow([...resp.data.items]);
                itemsRef.current = [...resp.data.items];
                setParams((prev) => ({ ...prev, itemsShown: [...resp.data.items] }));
                if (resp.data.pager) {
                    pagerModelRef.current.active = true;
                    pagerModelRef.current.paging.update(resp.data.pager);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <BoxFilterDevices
                items={items}
                setItemsShown={(items) => setParams((prev) => ({ ...prev, itemsShown: items }))}
                show={buttonsTB.filter.click}
                filters={filters.current}
                buttonsTB={buttonsTB}
                setButtonsTB={setButtonsTB}
            />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            {/* <div
                className="row"
                // style={buttonsTB.filter.click ? {marginTop: "50px"} : {}}
            > */}
            <div className="row">
                <div className={showPrev ? "col-md-9" : "col-md-12"}>
                    <LoaderSpinner isLoading={isLoading}>
                        <TableAssetDevices
                            itemsShow={params.itemsShown}
                            items={items}
                            checkAll={selectAll}
                            setCheckAll={setSelectAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            deviceTypes={arrayToObjectByPairs(params.types)}
                            deviceStatus={params.status}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {showPrev && (
                    <div className="col-md-3">
                        <PrevAssetDevices item={item} showPreview={showPrev} deviceStatus={params.status} />
                    </div>
                )}
            </div>
            <ConditionalRender condition={showForm}>
                <FormDevice
                    item={item}
                    setShowCanvas={setShowForm}
                    showCanvas={showForm}
                    title={titleForm}
                    deviceTypes={params.types}
                    deviceModels={params.models}
                    deviceGroups={params.groups}
                    deviceStatus={params.statusList}
                    fetchDevices={applyFilters}
                />
            </ConditionalRender>
            <ConditionalRender condition={showModalMassive}>
                <ModalDeviceMassive
                    show={showModalMassive}
                    setShow={setShowModalMassive}
                    items={items}
                    setItemsShow={setItemsShow}
                />
            </ConditionalRender>
        </>
    );
};
export default ViewDevices;
